//export const server = "http://localhost:5000/graphql";
export const server = "https://mamatovai-serve.herokuapp.com/graphql";

///----Old ----\\
//export const server = "https://mamato-vai-server.herokuapp.com/graphql";

//export const serverUrl = "https://naodas-server.herokuapp.com/graphql";

//const API_KEY = "AIzaSyCnlwozEPLpM58UqIkb2OKfhVEkTP3aGUQ";

export const categories = [
  {
    id: 1,
    name: "Grocerry",
  },
  {
    id: 2,
    name: "Electronics and Computer",
  },
  {
    id: 3,
    name: "Mobile and Accessories",
  },
  {
    id: 4,
    name: "Furniture and Housing",
  },
  {
    id: 5,
    name: "Technical Services",
  },
];
export const cities = [
  {
    id: 1,
    name: "Dhaka",
    thana: [
      {
        id: 1,
        name: "Utthora",
      },
      {
        id: 2,
        name: "Banani",
      },
    ],
  },
  {
    id: 2,
    name: "Sylhet",
    thana: [
      {
        id: 3,
        name: "Uposhohor",
      },
      {
        id: 4,
        name: "Medical",
      },
    ],
  },
];
